// extracted by mini-css-extract-plugin
export default {"breedImage":"BreedImage_breedImage__XUtwq"};